var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useDealItemPicker } from './DealItemPicker';
import { Money } from 'components/Money';
import { Table } from 'components/table/Table';
import { Text } from 'components/Text';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { getFieldValueLabel } from 'helpers/Field';
import { useTranslation } from 'components/translation/TranslationProvider';
import { Button } from 'components/Button';
import { calculatePriceCurrency } from 'helpers/Pricing';
import { FormIconCheckBox } from 'components/form/FormIconCheckBox';
import { SaleItemViewer } from 'components/saleItem/SaleItemViewer';
import { useModal } from 'components/modal/ModalStack';
import { SaleItemVariantQuery } from 'graphql/SaleItemVariant/queries/SaleItemVariantQuery';
import './DealItemPickerConfigTable.scss';
import { useLazyQuery } from '@apollo/client/react';
/**
 * @component DealItemPickerConfigTable
 * @since 1.0.0
 */
export function DealItemPickerConfigTable(props) {
    let { values, ready } = props;
    const { language } = useTranslation();
    const modal = useModal();
    const { setVariant, setAvailableOptions, item, variant, deal, setPane } = useDealItemPicker();
    const [getVariant] = useLazyQuery(SaleItemVariantQuery);
    const promotedFields = [];
    values === null || values === void 0 ? void 0 : values.map((value) => {
        var _a;
        (_a = value.fieldValues) === null || _a === void 0 ? void 0 : _a.map((fieldValue) => {
            if (fieldValue.field.promote) {
                // if field not already in promotedFields
                if (!promotedFields.find((field) => field.id === fieldValue.field.id)) {
                    promotedFields.push(fieldValue.field);
                }
            }
        });
    });
    /**
     * @function onPress
     * @since 1.0.0
     * @hidden
     */
    const onPress = (value) => {
        if (value) {
            modal.present({
                title: value.sku,
                picto: '',
                className: 'deal-sale-item-selector-item-modal',
                modal: React.createElement(SaleItemViewer, { item: item || value.item, variant: value })
            });
        }
    };
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(checked, value) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (checked) {
                setVariant(value);
                const { data } = yield getVariant({
                    variables: { input: { id: value.id } }
                });
                const variantWithOptions = (_a = data === null || data === void 0 ? void 0 : data.saleItemVariant) !== null && _a !== void 0 ? _a : value;
                setVariant(variantWithOptions);
                setAvailableOptions(variantWithOptions);
                const hasPackages = (_c = (_b = item === null || item === void 0 ? void 0 : item.packages) === null || _b === void 0 ? void 0 : _b.filter((pack) => pack.package.active).length) !== null && _c !== void 0 ? _c : 0;
                if (!hasPackages) {
                    if (!((_d = item === null || item === void 0 ? void 0 : item.options) === null || _d === void 0 ? void 0 : _d.length)) {
                        setPane(4);
                    }
                    else {
                        setPane(3);
                    }
                }
                else {
                    setPane(2);
                }
            }
        });
    }
    /**
     * @function getPackagesTotal
     * @since 1.0.0
     * @hidden
     */
    function getPackagesTotal(value) {
        let total = 0;
        if (item) {
            item.packages.forEach((pack) => {
                total += pack.locked || pack.included ? pack.package.price : 0;
            });
        }
        return total;
    }
    /**
     * @function getOptionsTotal
     * @since 1.0.0
     * @hidden
     */
    function getOptionsTotal(value) {
        let total = 0;
        if (item) {
            item.options.forEach((opt) => {
                total += opt.locked || opt.included ? opt.price : 0;
            });
        }
        if (value) {
            value.options.forEach((opt) => {
                total += opt.locked || opt.included ? opt.price : 0;
            });
        }
        return total;
    }
    const columns = [];
    columns.push({
        column: 'info',
        width: 'min',
        header: '',
        footer: '',
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(Button, { style: "picto", picto: "circle-info", onPress: () => onPress(value) })));
        }
    });
    columns.push({
        column: 'sku',
        header: t('sku'),
        footer: t('sku'),
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(Text, { className: "table-row-value", value: value === null || value === void 0 ? void 0 : value.sku })));
        }
    });
    columns.push({
        column: 'title',
        header: t('Name'),
        footer: t('Name'),
        render: (value) => {
            const fieldValues = value.values
                .map((val) => getFieldValueLabel(val.value, val.field, language))
                .join(' - ');
            return (React.createElement(Fragment, null,
                React.createElement(Text, { className: "table-row-value", value: `${item === null || item === void 0 ? void 0 : item.title} - ${fieldValues}` })));
        }
    });
    if (promotedFields === null || promotedFields === void 0 ? void 0 : promotedFields.length) {
        promotedFields.forEach((field) => {
            columns.push({
                column: field.id,
                header: field.title,
                footer: field.title,
                render: (value) => {
                    var _a, _b, _c;
                    return (React.createElement(Fragment, null,
                        React.createElement(Text, { className: "table-row-value", value: value.fieldValues &&
                                ((_a = value.fieldValues) === null || _a === void 0 ? void 0 : _a.find((v) => v.field.id === field.id))
                                ? getFieldValueLabel((_c = (_b = value.fieldValues) === null || _b === void 0 ? void 0 : _b.find((v) => v.field.id === field.id)) === null || _c === void 0 ? void 0 : _c.value, field, language)
                                : '' })));
                }
            });
        });
    }
    columns.push({
        column: 'price',
        header: t('Base Price'),
        footer: t('Base Price'),
        align: 'right',
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(Money, { className: "table-row-value", value: value.price
                        ? calculatePriceCurrency(value.price, deal === null || deal === void 0 ? void 0 : deal.currency)
                        : value.price })));
        }
    });
    columns.push({
        column: 'price',
        header: t('Packages'),
        footer: t('Packages'),
        align: 'right',
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(Money, { className: "table-row-value", value: value.price
                        ? calculatePriceCurrency(getPackagesTotal(value), deal === null || deal === void 0 ? void 0 : deal.currency)
                        : value.price })));
        }
    });
    columns.push({
        column: 'price',
        header: t('Options'),
        footer: t('Options'),
        align: 'right',
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(Money, { className: "table-row-value", value: value.price
                        ? calculatePriceCurrency(getOptionsTotal(value), deal === null || deal === void 0 ? void 0 : deal.currency)
                        : value.price })));
        }
    });
    columns.push({
        column: 'total',
        header: t('Total'),
        footer: t('Total'),
        align: 'right',
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(Money, { className: "table-row-value", value: value.price
                        ? calculatePriceCurrency(value.price +
                            getPackagesTotal(value) +
                            getOptionsTotal(value), deal === null || deal === void 0 ? void 0 : deal.currency)
                        : value.price })));
        }
    });
    columns.push({
        column: 'check',
        width: 'min',
        header: '',
        footer: '',
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(FormIconCheckBox, { checkedColor: "secondary", checkedIcon: "fal check", uncheckedIcon: "fal plus", checked: (variant === null || variant === void 0 ? void 0 : variant.id) === value.id, onChange: () => void onChange(true, value) })));
        }
    });
    // Build schema
    const schema = {};
    columns.forEach((column, index) => {
        schema['c' + (index + 1)] = column;
    });
    if (values == null) {
        values = [];
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Table, { className: "deal-item-picker-config-table", ready: ready, schema: schema, values: values, sortable: ['c2', 'c3', 'c4'], primaryColumn: "c3", actionsColumn: "c8", onRowClick: (value) => {
                void onChange(true, value);
            } })));
}
